var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "246px",
    height: "146px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(255, 255, 255)",
    d: "M112.500,-0.000 L246.000,-0.000 L246.000,146.000 L0.000,146.000 L66.000,30.417 C77.363,10.196 90.806,0.380 112.500,-0.000 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(93, 97, 109)",
    d: "M190.588,36.528 L165.988,61.151 L190.280,85.465 C191.953,87.140 192.173,89.636 190.771,91.039 C189.368,92.443 186.875,92.223 185.201,90.548 L160.909,66.234 L136.584,90.581 C134.904,92.263 132.400,92.484 130.992,91.075 C129.584,89.665 129.804,87.159 131.485,85.478 L155.810,61.130 L131.417,36.715 C129.744,35.040 129.524,32.544 130.926,31.141 C132.329,29.737 134.822,29.957 136.496,31.632 L160.889,56.047 L185.489,31.424 C187.169,29.742 189.673,29.522 191.081,30.931 C192.489,32.340 192.269,34.846 190.588,36.528 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.29e256b98a9c52a80027f22d9aba2e2c.svg";
export { ForwardRef as ReactComponent };